import { FunctionalInterfaceVersionParams } from "@/types/functionalInterfaceTypes";
import { VersionStatus, VersionType } from "@/types/genericVersionTypes";

export class FunctionalInterfaceVersion {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  functionalInterfaceId: string;
  majorVersion: number;
  minorVersion: number;
  patchVersion: number;
  status: VersionStatus;
  latest: boolean;
  versionString: string;

  constructor(params: FunctionalInterfaceVersionParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.functionalInterfaceId = params.functionalInterfaceId;
    this.majorVersion = params.majorVersion;
    this.minorVersion = params.minorVersion;
    this.patchVersion = params.patchVersion;
    this.status = params.status;
    this.latest = params.latest;
    this.versionString = `${this.majorVersion}.${this.minorVersion}.${this.patchVersion}`;
  }

  nextVersion(versionType: VersionType) {
    if (versionType === VersionType.MAJOR) {
      return { majorVersion: this.majorVersion + 1, minorVersion: 0, patchVersion: 0 };
    }

    if (versionType === VersionType.MINOR) {
      return { majorVersion: this.majorVersion, minorVersion: this.minorVersion + 1, patchVersion: 0 };
    }

    return { majorVersion: this.majorVersion, minorVersion: this.minorVersion, patchVersion: this.patchVersion + 1 };
  }

  nextVersionString(versionType: VersionType) {
    const nextVersion = this.nextVersion(versionType);
    return `${nextVersion.majorVersion}.${nextVersion.minorVersion}.${nextVersion.patchVersion}`;
  }
}
